import * as React from "react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { Stack as StackCurrent } from "@fluentui/react";
import { useV9StackEnabled } from "../../hooks/useStackExperiments";
import type { StackProps, StackState } from "./Stack.types";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IStackProps } from "@fluentui/react";
import { renderStack } from "./renderStack";
import { useStack } from "./useStack";
import { useStackStyles } from "./useStackStyles.styles";
import type { ForwardRefComponent } from "@fluentui/react-components";

export const StackNext: ForwardRefComponent<StackProps> = React.memo(
  React.forwardRef<HTMLDivElement, StackProps>((props, ref) => {
    const state: StackState = useStack(props, ref);

    useStackStyles(state);

    return renderStack(state);
  })
);

StackNext.displayName = "next/StackNext";

export const Stack = React.memo((props: IStackProps | StackProps) => {
  return useV9StackEnabled() ? (
    <StackNext {...(props as StackProps)} />
  ) : (
    <StackCurrent {...(props as IStackProps)} />
  );
});
